import { columnsStyle } from './columns.css';
import { clsx } from 'clsx';

type ColumnsProps<E extends React.ElementType = 'div'> = {
  as?: E;
} & Omit<React.ComponentPropsWithRef<E>, 'as'>;

export const Columns = <E extends React.ElementType = 'div'>({ as, ...props }: ColumnsProps<E>) => {
  const Component = as || 'div';
  const { className, ...rest } = props;
  return <Component className={clsx(columnsStyle, className)} {...rest} />;
};
